import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import downloadIcon from '../../assets/downloadIcon.png'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

const ProgramManagerProgramGrid = (props) => {

  const [expandedProgram, setExpandedProgram] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [partnersData, setPartnersData] = useState([]);

  const gridRef = useRef();
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  useEffect(() => {
    const selectedManager = props.selectedProgramManager?.value
    setExpandedProgram(null);
    if (selectedManager && props.programDataManager) {
      const programData = props.programDataManager
      setRowData(programData);
    } else {
      setRowData([]);
    }
  }, [props.selectedProgramManager, props.programDataManager])

  useEffect(() => {
    setPartnersData([])

    if (props.selectedProgramName && props.partnerDataForSelectedProgram) {
      setPartnersData(props.partnerDataForSelectedProgram);
    } else {
      setPartnersData([]);
    }
  }, [props.selectedProgramName, props.partnerDataForSelectedProgram])

  useEffect(() => {
    setPartnersData(props.partnerDataForSelectedProgram);
  }, [partnersData]);

  const handleProgramClick = (program) => {
    setPartnersData([])
    const programName = program.sPackageTitle;
    props.setSelectedProgramName(program.sPackageTitle)
    setExpandedProgram(expandedProgram === programName ? null : programName);

    if (expandedProgram !== programName) {
      props.getPartnerDataForSelectedProgram(props.selectedProgramManager.value, programName)
      setPartnersData(props.partnerDataForSelectedProgram);
    } else {
      setPartnersData([]);
    }
  };

  const footerRow = {
    sPackageTitle: "Total",
    FTU_Count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.FTU_Count, 0),
    EU_Count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.EU_Count, 0),
  };

  const subfooterRow = {
    sEntryPoint: "Total",
    FTU_Count: "Total" + " : " + " " + partnersData.reduce((total, row) => total + row.FTU_Count, 0),
    EU_Count: "Total" + " : " + " " + partnersData.reduce((total, row) => total + row.EU_Count, 0),
  };

  const columnDefs = [
    {
      headerName: 'Program Name',
      field: 'sPackageTitle',
      cellStyle: { 'white-space': 'normal' },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
      cellRenderer: params => {
        let resourceName = params.value;
        if (resourceName === "null") {
          resourceName = "Not Provided";
        }
        if (resourceName === "Total") {
          return <div style={{ textAlign: "right", display: 'none' }}>{resourceName}</div>;
        } else {
          return resourceName;
        }
      },
      width: 350,
    },
    {
      headerName: 'FTC',
      field: 'FTU_Count',
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      headerName: 'EU', field: 'EU_Count',
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ];

  const subColumnDefs = [
    {
      headerName: "Partner Name", field: "sEntryPoint",
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
      cellRenderer: params => {
        let resourceName = params.value;
        if (resourceName === "null") {
          resourceName = "Not Provided";
        }
        if (resourceName === "Total") {
          return <div style={{ textAlign: "right", display: 'none' }}>{resourceName}</div>;
        } else {
          return resourceName;
        }
      },
      width: 350,
    },
    {
      headerName: "FTC", field: "FTU_Count",
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
    {
      headerName: "EU", field: "EU_Count",
      flex: 1,
      sortable: true,
      pinnedBottomRowCellRenderer: "agGroupCellRenderer",
      cellStyle: { textAlign: "right" },
      headerComponentFramework: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: 'flex-end', width: '100%', alignItems: "center" }}>
            <div>{params.displayName}</div>
          </div>
        );
      },
    },
  ]

  const gridOptions = useMemo(() => ({
    suppressScrollOnNewData: true,
  }), []);


  return (
    <div className="mb-5">
      {
        props.selectedProgramManager?.value &&
        <div>
          {/* Program Manager Dropdown */}
          <h3
            className="spled-colored-label"
            style={{
              fontSize: "20px",
              marginRight: 10,
              margin: 10
            }}
          >
            Program Data for Program Manager
          </h3>

          {/* Grid Display */}
          <div style={{ height: "50vh", boxSizing: "border-box" }}>
            <div style={gridStyle} className="ag-theme-material">
              <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                rowSelection="single"
                onRowClicked={(event) => handleProgramClick(event.data)}
                pinnedBottomRowData={[footerRow]}
                overlayNoRowsTemplate={
                  '<span class="ag-overlay-loading-center">loading...</span>'
                }
                rowClassRules={{
                  "total-row": 'data.sPackageTitle === "Total"',
                }}
              />
            </div>
          </div>

          {/* Detail View */}
          {expandedProgram && (
            <div className="mt-3" style={{ height: "50vh", boxSizing: "border-box" }}>
              <div className="ag-theme-material" style={gridStyle}>
                <h2
                  className="spled-colored-label"
                  style={{
                    fontSize: "20px",
                    marginRight: 10,
                    margin: 10
                  }}>Partners for {expandedProgram}</h2>
                <AgGridReact
                  columnDefs={subColumnDefs}
                  rowData={partnersData}
                  pinnedBottomRowData={[subfooterRow]}
                  overlayNoRowsTemplate={
                    '<span class="ag-overlay-loading-center">loading...</span>'
                  }
                  rowClassRules={{
                    "total-row": 'data.sEntryPoint === "Total"',
                  }}
                />
              </div>
            </div>
          )}
        </div>
      }
    </div>

  );
};


export default ProgramManagerProgramGrid